import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";

const NAMESPACE = "translation";
export function useFlightTranslation() {
  const { t, i18n, ready } = useTranslation(NAMESPACE);

  /** if fallbackText is not passed and is needed, we'll simply remove the underscores from text
   *
   *  Interpolation Docs : https://www.i18next.com/translation-function/interpolation#basic
   */
  const translate = useCallback(
    (
      text: string,
      fallbackText?: string,
      interpolatedData?: { [key: string]: string | number }
    ) => {
      if (ready) {
        const fallback =
          fallbackText || (text ? String(text).split("_").join(" ") : "");
        return i18n.exists(text) ? t(text, interpolatedData) : fallback;
      }
      return "";
    },
    [t, i18n, ready]
  );

  return useMemo(() => {
    return { t, i18n, translate };
  }, [t, i18n, translate]);
}
